import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { UpdateContactInput } from "@/gql/graphql";
import { ContactDetailsForm } from "@/app/Contacts/Forms/ContactDetailsForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateContactMutation } from "@/app/Contacts/GraphQL/contactMutations";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { AddressInput } from "@/app/Address/Components/AddressInput";

export function ContactDetailsScreen() {
  const record = useContactRecord();
  const { mutateAsync } = useGqlMutation(updateContactMutation);

  return (
    <div className="space-y-12 py-6">
      <RecordScreenFormCard<UpdateContactInput>
        initialValues={{
          name: record.name,
          company_number: record.company_number,
          legal_name: record.legal_name,
          purchase_order_number: record.purchase_order_number,
          billing_cycle_day_of_month: record.billing_cycle_day_of_month,
          billing_email: record.billing_email,
          billing_phone: record.billing_phone,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: record.id,
            input: values,
          });
        }}
        title="Details"
      >
        <ContactDetailsForm contact={record} />
      </RecordScreenFormCard>

      <RecordScreenFormCard<UpdateContactInput>
        initialValues={{
          billingAddress: {
            upsert: {
              id: record.billingAddress?.id,
              city: record.billingAddress?.city ?? null,
              country: record.billingAddress?.country ?? null,
              postcode: record.billingAddress?.postcode ?? null,
              address_line_1: record.billingAddress?.address_line_1 ?? null,
              address_line_2: record.billingAddress?.address_line_2 ?? null,
              state: record.billingAddress?.state ?? null,
            },
          },
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: record.id,
            input: values,
          });
        }}
        title="Billing address"
      >
        <AddressInput
          name="billingAddress.upsert"
          label="Address"
          className="col-span-5"
          initialLat={record.billingAddress?.lat}
          initialLng={record.billingAddress?.lng}
        />
      </RecordScreenFormCard>
    </div>
  );
}
